import { Action } from '@ngrx/store';
import { NotificationInterface, NotificationTemplateInterface } from 'app/notifications/models';

import { NotificationActionType } from './notification-action-type.enum';

export class NotificationBulkUpdatePayload {

  public readState: boolean;
  public notifications: NotificationInterface[];

  constructor({
    readState = undefined,
    notifications = undefined,
  }: NotificationBulkUpdatePayload) {
    this.readState = readState;
    this.notifications = notifications;
  }
}

export class UpdateNotification implements Action {
  public readonly type: NotificationActionType = NotificationActionType.UpdateNotification;

  constructor(public readonly payload: NotificationInterface) { }
}

export class UpdateNotificationsReadState implements Action {
  public readonly type: NotificationActionType = NotificationActionType.UpdateNotificationsReadState;

  constructor(public readonly payload: NotificationBulkUpdatePayload) { }
}

export class UpdateNotificationCompleted implements Action {
  public readonly type: NotificationActionType = NotificationActionType.UpdateNotificationCompleted;

  constructor(public readonly payload: NotificationInterface) { }
}

export class UpdateNotificationsReadStateCompleted implements Action {
  public readonly type: NotificationActionType = NotificationActionType.UpdateNotificationsReadStateCompleted;

  constructor(public readonly payload: NotificationInterface[]) { }
}

export class UpdateNotificationFailed implements Action {
  public readonly type: NotificationActionType = NotificationActionType.UpdateNotificationFailed;

  constructor(public readonly payload: string) { }
}

export class CreateNotificationTemplate implements Action {
  public readonly type: NotificationActionType = NotificationActionType.CreateNotificationTemplate;

  constructor(public readonly payload: NotificationTemplateInterface) { }
}

export class UpdateNotificationTemplate implements Action {
  public readonly type: NotificationActionType = NotificationActionType.UpdateNotificationTemplate;

  constructor(public readonly payload: NotificationTemplateInterface) { }
}

export class UpdateNotificationTemplateComplete implements Action {
  public readonly type: NotificationActionType = NotificationActionType.UpdateNotificationTemplateComplete;

  constructor(public readonly payload: NotificationTemplateInterface) { }
}

export class UpdateNotificationTemplateFailed implements Action {
  public readonly type: NotificationActionType = NotificationActionType.UpdateNotificationTemplateFailed;

  constructor(public readonly payload: string) { }
}
